export default "__VITE_ASSET__BS$S0UYX__"